import { TObject } from 'utils/types';

import { IRuleset } from './types';

export const normalizeRuleset = (data: TObject): IRuleset => {
  return {
    rulesetEnabled: !!data?.rulesetEnabled,
    rulesetId: (data?.rulesetId as number) || 0,
    terminalLinkDescription: (data?.terminalLinkDescription as string) || '',
  };
};
